import styled from 'styled-components'

export const NotificationBadge = styled.span`
  background-color: var(--red);
  height: 0.5rem;
  width: 0.5rem;
  position: absolute;
  top: 0;
  right: -0.125rem;
  border-radius: 50%;
`

NotificationBadge.displayName = 'NotificationBadge'
